// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as DatenschutzDothtmlRouteImport } from './routes/datenschutz[.]html'
import { Route as FilmRouteImport } from './routes/film'
import { Route as FotoRouteImport } from './routes/foto'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as ImpressumDothtmlRouteImport } from './routes/impressum[.]html'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SocialmediaRouteImport } from './routes/socialmedia'
import { Route as TerminRouteImport } from './routes/termin'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as LocationsSplatRouteImport } from './routes/locations/$'
import { Route as OauthCallbackRouteImport } from './routes/oauth/callback'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio/index'
import { Route as PortfolioSlugRouteImport } from './routes/portfolio/$slug'
import { Route as PortfolioIndustryIndustryRouteImport } from './routes/portfolio/industry/$industry'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const DatenschutzDothtmlRoute = DatenschutzDothtmlRouteImport.update({
            id: '/datenschutz.html',path: '/datenschutz.html',getParentRoute: () => rootRouteImport
          })
const FilmRoute = FilmRouteImport.update({
            id: '/film',path: '/film',getParentRoute: () => rootRouteImport
          })
const FotoRoute = FotoRouteImport.update({
            id: '/foto',path: '/foto',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const ImpressumDothtmlRoute = ImpressumDothtmlRouteImport.update({
            id: '/impressum.html',path: '/impressum.html',getParentRoute: () => rootRouteImport
          })
const ImprintRoute = ImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SocialmediaRoute = SocialmediaRouteImport.update({
            id: '/socialmedia',path: '/socialmedia',getParentRoute: () => rootRouteImport
          })
const TerminRoute = TerminRouteImport.update({
            id: '/termin',path: '/termin',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const LocationsSplatRoute = LocationsSplatRouteImport.update({
            id: '/locations/$',path: '/locations/$',getParentRoute: () => rootRouteImport
          })
const OauthCallbackRoute = OauthCallbackRouteImport.update({
            id: '/oauth/callback',path: '/oauth/callback',getParentRoute: () => rootRouteImport
          })
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
            id: '/portfolio/',path: '/portfolio/',getParentRoute: () => rootRouteImport
          })
const PortfolioSlugRoute = PortfolioSlugRouteImport.update({
            id: '/portfolio/$slug',path: '/portfolio/$slug',getParentRoute: () => rootRouteImport
          })
const PortfolioIndustryIndustryRoute = PortfolioIndustryIndustryRouteImport.update({
            id: '/portfolio/industry/$industry',path: '/portfolio/industry/$industry',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,AgbRoute: AgbRoute,AuthRoute: AuthRoute,DatenschutzRoute: DatenschutzRoute,DatenschutzDothtmlRoute: DatenschutzDothtmlRoute,FilmRoute: FilmRoute,FotoRoute: FotoRoute,ImpressumRoute: ImpressumRoute,ImpressumDothtmlRoute: ImpressumDothtmlRoute,ImprintRoute: ImprintRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SocialmediaRoute: SocialmediaRoute,TerminRoute: TerminRoute,BlogSlugRoute: BlogSlugRoute,LocationsSplatRoute: LocationsSplatRoute,OauthCallbackRoute: OauthCallbackRoute,PortfolioSlugRoute: PortfolioSlugRoute,BlogIndexRoute: BlogIndexRoute,PortfolioIndexRoute: PortfolioIndexRoute,PortfolioIndustryIndustryRoute: PortfolioIndustryIndustryRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)